import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.scss']
})
export class ForgotPasswordDialogComponent {
  email: string = '';
  isSubmitting: boolean = false;
  message: string = '';

  constructor(
    public dialogRef: MatDialogRef<ForgotPasswordDialogComponent>,
    private authService: AuthService
  ) { }

  async onSubmit() {
    if (!this.email) return;

    this.isSubmitting = true;
    this.message = '';

    try {
      await this.authService.sendPasswordReset(this.email);
      this.message = 'If an account exists with this email, a password reset link has been sent.';
    } catch (error) {
      // For security, do not reveal if the email exists or not.
      this.message = 'If an account exists with this email, a password reset link has been sent.';
      console.error(error);
    } finally {
      this.isSubmitting = false;
    }
  }
}
